<template>
  <div :style="wrapperStyle">
    <StatisticGroup
      :title="group.label"
      :description="group.description"
      :extra="group.extra"
      :collapsible="group.collapsible"
      :default-collapsed="group.defaultCollapsed"
      width-mode="container"
      :theme="group.theme ?? theme"
      :size="size"
      :border="border"
      :equal-height="equalHeight"
      :reverse-color="reverseColor"
      :number-scroll="numberScroll"
      :sub-indicators-layout="subIndicatorsLayout"
    >
      <StatisticGrid
     :data="group.data"
        :columns="group.columns ?? 1"
        :pagination="group.pagination"
        :size="size"
        :border="border"
        :equal-height="equalHeight"
        :reverse-color="reverseColor"
        :number-scroll="numberScroll"
        :sub-indicators-layout="subIndicatorsLayout"
        :control-type="selectionProps.controlType"
        :value="selectionProps.value"
        :max-length="(selectionProps as any).maxLength"
        :min-length="(selectionProps as any).minLength"
        @change="$emit('change', $event)"
        @update:value="$emit('update:value', $event)"
      />
    </StatisticGroup>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import StatisticGroup from '../containers/statistic-group.vue'
import StatisticGrid from '../containers/statistic-grid.vue'
import type { StatisticCardSize, StatisticCardSelectionValue, PaginationConfig, StatisticVNode } from '../types'

defineOptions({ name: 'JdStatisticSuperGroupSection' })


interface SelectionProps {
  controlType: 'radio' | 'checkbox' | null
  value?: StatisticCardSelectionValue | StatisticCardSelectionValue[]
  maxLength?: number
  minLength?: number
}

interface SuperGroupItem {
  key?: string | number
  label?: StatisticVNode
  description?: StatisticVNode
  extra?: StatisticVNode
  collapsible?: boolean
  defaultCollapsed?: boolean
  theme?: string
  columns?: number
  pagination?: PaginationConfig
  data: any[]
}

const props = defineProps<{
  group: SuperGroupItem
  selectionProps: SelectionProps
  layout?: 'horizontal' | 'vertical'
  theme?: string
  size?: StatisticCardSize
  border?: boolean
  equalHeight?: boolean
  reverseColor?: boolean
  numberScroll?: boolean
  subIndicatorsLayout?: 'horizontal' | 'vertical'
}>()

defineEmits<{
  (e: 'change', value: StatisticCardSelectionValue | StatisticCardSelectionValue[]): void
  (e: 'update:value', value: StatisticCardSelectionValue | StatisticCardSelectionValue[]): void
}>()

const wrapperStyle = computed(() => ({
  flex: props.layout === 'horizontal' ? 1 : undefined,
  width: props.layout === 'vertical' ? '100%' : undefined,
  minWidth: 0,
}))
</script>
